import { UserRole, OrganizationRole, ProjectRole } from '@types'

import { useAppState } from '../app/app-state.hook'
import { useMe } from './me.hook'

export const useHasRoles = (): {
  hasRoles: (params: {
    userRoles?: UserRole[]
    organizationRoles?: OrganizationRole[]
    projectRoles?: ProjectRole[]
    projectId?: string
  }) => boolean
  loading: boolean
} => {
  const { organization } = useAppState()

  const { data, loading } = useMe()
  const user = data?.me

  const hasRoles = (params: {
    userRoles?: UserRole[]
    organizationRoles?: OrganizationRole[]
    projectRoles?: ProjectRole[]
    projectId?: string
  }): boolean => {
    const { userRoles = [], organizationRoles = [], projectRoles = [], projectId } = params

    let authorized = false

    if (user) {
      authorized = userRoles.indexOf(user.role) != -1

      if (!authorized && organization) {
        const { organizationACL } = user
        const rbac = organizationACL.find((rbac) => rbac.organization.id == organization.id)
        authorized = !!rbac && organizationRoles.indexOf(rbac.role) != -1
      }

      if (!authorized && projectId) {
        const { projectACL } = user
        const rbac = projectACL.find((rbac) => rbac.project.id == projectId)
        authorized = !!rbac && projectRoles.indexOf(rbac.role) != -1
      }
    }

    return authorized
  }

  return { hasRoles, loading }
}
